/* eslint-disable */
export default {
  order: 1,
  header: [
    {
      category: '概览',
      item: [
        {
          title: '',
          list: [
            {
              name: '什么是 EnOS',
              url: '/docs/enos/zh_CN/3.1.0/overview/enos_introduction.html'
            },
            {
              name: 'EnOS 优势',
              url: '/docs/enos/zh_CN/3.1.0/overview/advantage.html'
            },
            {
              name: '关键概念',
              url: '/docs/enos/zh_CN/3.1.0/overview/concepts.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    },
    {
      category: '产品文档',
      item: [
        {
          title: '应用构建',
          list: [
            {
              name: '数字孪生可视化',
              url: '/docs/dtv/zh_CN/3.1.0/overview.html'
            },
            {
              name: '统一监测',
              url: '/docs/monitor/zh_CN/3.1.0/overview/monitor_overview.html'
            },
            {
              name: '报表工具',
              url: '/docs/reporting/zh_CN/3.1.0/overview.html'
            },
            {
              name: '告警管理',
              url: '/docs/alarm-management/zh_CN/3.1.0/overview/about.html'
            },
            {
              name: '告警引擎',
              url: '/docs/alert/zh_CN/3.1.0/learn/alert_overview.html'
            },
            {
              name: '工作管理',
              url: '/docs/wmt/zh_CN/3.1.0/about.html'
            },
            {
              name: '通知管理',
              url: '/docs/notification-mgmt/zh_CN/3.1.0/notification_center_overview.html'
            },
            {
              name: '应用门户',
              url: '/docs/app-portal/zh_CN/3.1.0/overview.html'
            },
            {
              name: '集群控制',
              url: '/docs/control/zh_CN/3.1.0/overview.html'
            },
            {
              name: '应用注册',
              url: '/docs/app-development/zh_CN/3.1.0/app_management/overview.html'
            },
            {
              name: 'API 管理',
              url: '/docs/apim/zh_CN/3.1.0/api_management_overview.html'
            }
          ]
        },
        {
          title: '数据管理与分析',
          list: [
            {
              name: '数据订阅',
              url: '/docs/data-subscription/zh_CN/3.1.0/data_subscription_overview.html'
            },
            {
              name: '数据归档',
              url: '/docs/data-archiving/zh_CN/3.1.0/archive_policy.html'
            },
            {
              name: '数据源注册',
              url: '/docs/data-source-reg-app/zh_CN/3.1.0/datasource_overview.html'
            },
            {
              name: '模型管理',
              url: '/docs/modelling-tool/zh_CN/3.1.0/overview/about.html'
            }
          ]
        },
        {
          title: '设备连接与管理',
          list: [
            {
              name: '设备连接',
              url: '/docs/device-connection/zh_CN/3.1.0/learn/message_flow.html'
            },
            {
              name: '设备管理',
              url: '/docs/device-connection/zh_CN/3.1.0/learn/device_lifecycle_management.html'
            },
            {
              name: '数据质量',
              url: '/docs/data-quality/zh_CN/3.1.0/overview/about.html'
            },
            {
              name: '设备数据集成服务',
              url: '/docs/device-integration/zh_CN/3.1.0/learn/device_integration_overview.html'
            },
            {
              name: 'EnOS Edge',
              url: '/docs/enos-edge/zh_CN/2.4.4/edge_overview.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      footer: {
        name: '查看所有产品',
        image: 'assets/images/header/document_center.svg',
        url: '/docs/zh_CN/3.1.0'
      },
      showListInMobile: false
    },
    {
      category: '教程',
      item: [
        {
          title: '数据集成',
          list: [
            {
              name: '将模拟设备连接到 EnOS Cloud',
              url: '/docs/device-connection/zh_CN/3.1.0/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: '将模拟电表接入到 EnOS Edge',
              url: '/docs/enos-edge/zh_CN/2.4.4/tutorial/connecting_edge.html'
            }
          ]
        },
        {
          title: '数据开发',
          list: [
            {
              name: '评估风机设备的数据质量',
              url: '/docs/data-quality/zh_CN/3.1.0/tutorial.html'
            }
          ]
        },
        {
          title: '应用开发',
          list: [
            {
              name: '基于行业应用组件构建应用',
              url: '/docs/app-development/zh_CN/3.1.0/app_dev_workflow/index.html'
            },
            {
              name: '创建智能电池仪表盘',
              url: '/docs/dtv/zh_CN/3.1.0/tutorial/index.html'
            },
            {
              name: '创建可视化监测应用',
              url: '/docs/monitor/zh_CN/3.1.0/tutorial/overview.html'
            }
          ]
        }
      ],
      layout: 'horizontal',
      footer: {
        name: '查看所有教程',
        image: 'assets/images/header/tutorial_center.svg',
        url: '/docs/zh_CN/3.1.0/tutorial'
      },
      showListInMobile: false
    },
    {
      category: '开发资源',
      item: [
        {
          title: '',
          list: [
            {
              name: 'EnOS APIs',
              url: 'https://developer.enos-iot.com/zh_CN/enos-apis/'
            },
            {
              name: 'SDKs 和工具',
              url: 'https://developer.enos-iot.com/zh_CN/enos-sdks-tools/'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    }
  ],
  content: {
    Cards: [
      {
        name: '入门信息',
        description: '了解 EnOS 的优势和关键概念。',
        image: 'assets/images/landing/cards/started_information.svg',
        url: '/docs/enos/zh_CN/3.1.0/overview/enos_introduction.html'
      },
      {
        name: '教程',
        description: '浏览核心场景教程，快速上手 EnOS。',
        image: 'assets/images/landing/cards/tutorial.svg',
        url: '/docs/zh_CN/3.1.0/tutorial'
      },
      {
        name: '版本管理指南',
        description: '了解 EnOS Cloud 产品发版机制和各版本文档查阅方法。',
        image: 'assets/images/landing/cards/version_guide.svg',
        url: '/docs/enos/zh_CN/3.1.0/release_management'
      },
      {
        name: '版本说明',
        description: '查看 EnOS 版本信息。',
        image: 'assets/images/landing/cards/version_description.svg',
        url: '/docs/enos/zh_CN/3.1.0/releasenotes/index.html'
      },
      {
        name: 'API 参考',
        description: '基于丰富的 Open APIs 访问 EnOS 资源，开发各类应用。',
        image: 'assets/images/landing/cards/api_reference.svg',
        url: '/docs/api/zh_CN/3.1.0/overview.html'
      },
      {
        name: 'SDKs 和工具',
        description: '获取 EnOS SDK 工具包，构建基于 EnOS 的应用程序。',
        image: 'assets/images/landing/cards/sdk_tools.svg',
        url: 'https://developer.enos-iot.com/zh_CN/enos-sdks-tools/'
      }
    ],
    Products: [
      {
        category: '应用构建',
        item: [
          {
            name: '数字孪生可视化',
            image: 'assets/images/landing/products/digital_twin_visualization.svg',
            url: '/docs/dtv/zh_CN/3.1.0/overview.html'
          },
          {
            name: '统一监测',
            image: 'assets/images/landing/products/unified_monitoring.svg',
            url: '/docs/monitor/zh_CN/3.1.0/overview/monitor_overview.html'
          },
          {
            name: '报表工具',
            image: 'assets/images/landing/products/reporting_tool.svg',
            url: '/docs/reporting/zh_CN/3.1.0/overview.html'
          },
          {
            name: '告警管理',
            image: 'assets/images/landing/products/alert_management.svg',
            url: '/docs/alarm-management/zh_CN/3.1.0/overview/about.html'
          },
          {
            name: '告警引擎',
            image: 'assets/images/landing/products/alert_management.svg',
            url: '/docs/alert/zh_CN/3.1.0/learn/alert_overview.html'
          },
          {
            name: '工作管理',
            image: 'assets/images/landing/products/work_management.svg',
            url: '/docs/wmt/zh_CN/3.1.0/about.html'
          },
          {
            name: '通知管理',
            image: 'assets/images/landing/products/schedule_management.svg',
            url: '/docs/notification-mgmt/zh_CN/3.1.0/notification_center_overview.html'
          },
          {
            name: '应用门户',
            image: 'assets/images/landing/products/application_portal.svg',
            url: '/docs/app-portal/zh_CN/3.1.0/overview.html'
          },
          {
            name: '集群控制',
            image: 'assets/images/landing/products/fleet_control.svg',
            url: '/docs/control/zh_CN/3.1.0/overview.html'
          },
          {
            name: '应用注册',
            image: 'assets/images/landing/products/data_source_registration 2.svg',
            url: '/docs/app-development/zh_CN/3.1.0/app_management/overview.html'
          },
          {
            name: 'API 管理',
            image: 'assets/images/app_bw.png',
            url: '/docs/apim/zh_CN/3.1.0/api_management_overview.html'
          }
        ]
      },
      {
        category: '数据管理与分析',
        item: [
          {
            name: '数据订阅',
            image: 'assets/images/landing/products/data_subscription.svg',
            url: '/docs/data-subscription/zh_CN/3.1.0/data_subscription_overview.html'
          },
          {
            name: '数据归档',
            image: 'assets/images/landing/products/data_source_registration.svg',
            url: '/docs/data-archiving/zh_CN/3.1.0/archive_policy.html'
          },
          {
            name: '数据源注册',
            image: 'assets/images/landing/products/data_source_registration 2.svg',
            url: '/docs/data-source-reg-app/zh_CN/3.1.0/datasource_overview.html'
          },
          {
            name: '模型管理',
            image: 'assets/images/landing/products/enos_mobile.svg',
            url: '/docs/modelling-tool/zh_CN/3.1.0/overview/about.html'
          }
        ]
      },
      {
        category: '设备连接与管理',
        item: [
          {
            name: '设备连接',
            image: 'assets/images/landing/products/device_connectivity.svg',
            url: '/docs/device-connection/zh_CN/3.1.0/learn/message_flow.html'
          },
          {
            name: '设备管理',
            image: 'assets/images/landing/products/device_management.svg',
            url: '/docs/device-connection/zh_CN/3.1.0/learn/device_lifecycle_management.html'
          },
          {
            name: '数据质量',
            image: 'assets/images/landing/products/data_quality.svg',
            url: '/docs/data-quality/zh_CN/3.1.0/overview/about.html'
          },
          {
            name: '设备数据集成服务',
            image: 'assets/images/landing/products/device_data_integration_service.svg',
            url: '/docs/device-integration/zh_CN/3.1.0/learn/device_integration_overview.html'
          },
          {
            name: 'EnOS Edge',
            image: 'assets/images/landing/products/device_provisioning_service.svg',
            url: '/docs/enos-edge/zh_CN/2.4.4/edge_overview.html'
          }     
        ]
      }
    ]
  }  
};